
import _ from "lodash"
export default {
  props: {
    checkoutInfo: {
      type: Array,
      default: () => []
    },
    yuuId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isShow: true,
      a: "xxxx"
    }
  },
  watch: {
    checkoutInfo: {
      handler(newVal) {},
      immediate: true
    }
  },
  mounted() {},
  methods: {
    handleCopy: _.debounce(function (orderId) {
      this.$copyText(String(orderId)).then(res => {
        this.$message({ message: this.$t("orderDetails.copySuccess"), type: "success", duration: 1000 })
      })
    }, 500)
  }
}
